import { KeyingConfig, UpdateResolver } from "@urql/exchange-graphcache";
import {
    App,
    CreateHandlerMutationVariables,
    DeleteHandlerMutationVariables,
    GetHandlerDocument,
    GetHandlersListDocument,
    GetHandlersListHandler,
    Handler,
    UpdateHandlerMutationVariables
} from "generated/graphql";
import { updateTypeName } from "utils/graphql/data";

function updateHandler(cached: Handler, vars: UpdateHandlerMutationVariables) {
    Object.assign(cached || {}, vars.handler);
}

export const intentKeys: KeyingConfig = {
    GetIntentsListIntent: (data: any) => data.intentId,
    Intent: (data: any) => data._id,
};

export const handlerUpdates: {
    [fieldName: string]: UpdateResolver;
} = {
    addHandler: (result: any, args, cache, info) => {
        const handler = result.addHandler as Handler;
        if (handler) {
            const vars = info.variables as CreateHandlerMutationVariables;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetHandlersListDocument,
                variables: { appId }
            }, data => {
                if (!data) {
                    return data;
                }
                const list = (data.app as App)?.handlers?.handlers;
                if (list) {
                    list.push(updateTypeName(handler as any as GetHandlersListHandler, "GetHandlersListHandler"));
                }

                return data;
            });
        }
    },
    deleteHandler: (result: any, args, cache, info) => {
        if (result.deleteHandler) {
            const vars = info.variables as DeleteHandlerMutationVariables;
            const handlerId = vars.handlerId;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetHandlerDocument,
                variables: { appId, intentId: handlerId }
            }, data => {
                if (typeof data?.handler === "object") {
                    // tslint:disable:no-null-keyword
                    data.handler = null;
                }

                return data;
            });

            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetHandlersListDocument,
                variables: { appId }
            }, data => {
                const list: GetHandlersListHandler[] = (data.app as App)?.handlers?.handlers;
                if (list) {
                    const index = list.findIndex(i => i.intentId === handlerId);
                    if (index >= 0) {
                        list.splice(index, 1);
                    }
                }

                return data;
            });
        }
    },
    updateHandler: (result: any, args, cache, info) => {
        if (result.updateHandler) {
            const vars = info.variables as UpdateHandlerMutationVariables;
            const handlerId = vars.handlerId;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetHandlerDocument,
                variables: { appId, intentId: handlerId }
            }, data => {
                if (typeof data?.handler === "object") {
                    updateHandler(data.handler as Handler, vars);
                }

                return data;
            });
        }
    }
};